export default {
      id: "charmFilter-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#charmFilter-usage",
      toString: function () {
        return this.url;
      }
    }